import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type Props = {
  titleKey: string;
  children: React.ReactNode;
};

const QuotationInputCard = ({ titleKey, children }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <Typography className={styles.numberedSectionTitle}>{t(titleKey)}</Typography>
      {children}
    </Box>
  );
};

export default QuotationInputCard;
